import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=6084653a&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"
import style0 from "./Filters.vue?vue&type=style&index=0&id=6084653a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports